<template>
    <v-app id="app">
        <!-- App bar -->
        <v-app-bar app clipped-right color="bal-gray" light flat>
            <v-app-bar-nav-icon large @click.stop="toggleDrawer" />
            <v-toolbar-title
                >{{ `${$route.meta.title}` | t
                }}<span style="color:gray;">{{ ` (${clientCount})` }}</span></v-toolbar-title
            >
            <v-combobox
                v-if="hasPermissionForAction(PermissionsConstants.EXPORT_CLIENT, PermissionsConstants.SEARCH)"
                :items="searchHistory"
                :value="searchClientString"
                @input="controlSearchString($event)"
                item-text="keyword"
                id="searchInput"
                class="mt-6 mx-2"
                :placeholder="'Client name, country, region, address, manager name, met place, comment' | t"
                prepend-inner-icon="search"
                flat
                solo
                dense
                clearable
            >
                <template slot="item" slot-scope="data">
                    <span
                        @click="updateClientSearch(data.item.keyword)"
                        style="width: 100%; height: 100%"
                        class="pa-2"
                        >{{ data.item.keyword }}</span
                    >
                </template>
            </v-combobox>
            <v-spacer v-else />
            <v-btn
                dark
                color="bal-dark-gray"
                class="px-2"
                v-if="hasPermissionForAction(PermissionsConstants.EXPORT_CLIENT, PermissionsConstants.FILTER)"
                @click.stop="toggleListSettingsModal"
                style="min-width: 0;"
            >
                <v-icon>settings</v-icon>
            </v-btn>
            <v-btn
                dark
                color="bal-red"
                class="px-2 ml-2"
                style="min-width: 0;"
                v-if="hasPermissionForAction(PermissionsConstants.EXPORT_CLIENT, PermissionsConstants.CREATE)"
                @click.stop="openNewProductDrawer"
            >
                <v-icon>add</v-icon>
            </v-btn>
        </v-app-bar>

        <!-- Drawer left -->
        <main-drawer :drawer-open="mainDrawerOpen" />

        <!--    Right drawer    -->
        <v-navigation-drawer :value="drawerOpen" fixed right hide-overlay width="900">
            <client-view v-if="$route.name === 'export-client-view'"></client-view>
            <client-edit v-if="$route.name === 'export-client-edit'"></client-edit>
        </v-navigation-drawer>

        <!-- Main content -->
        <v-main>
            <router-view />
        </v-main>

        <!-- Footer -->
        <page-footer />
        <client-list-settings-modal />

        <v-snackbar color="success" bottom :timeout="2500" :value="requestSuccess">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">check</v-icon>
                <div class="title pa-2 ">{{ "Success" | t }}</div>
            </div>
        </v-snackbar>

        <!-- Error snackbar -->
        <v-snackbar color="error" bottom :timeout="2500" :value="requestError">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">error</v-icon>
                <div class="title pa-2 ">{{ errorMessage }}</div>
            </div>
        </v-snackbar>
    </v-app>
</template>
<script>
import MainDrawer from "../components/main-drawer.vue";
import PageFooter from "../components/page-footer.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import Store from "../store";
import ClientView from "@/pages/export-clients/client-view";
import ClientEdit from "@/pages/export-clients/client-edit";
import ClientListSettingsModal from "@/pages/clients/client-list-settings-modal";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "export-client",
    components: {
        ClientListSettingsModal,
        ClientEdit,
        ClientView,
        PageFooter,
        MainDrawer
    },
    data() {
        return {
            mainDrawerOpen: null
        };
    },
    async created() {
        await Store.dispatch("SearchHistoryStore/getSearchHistory", this.$route.path.replace("/", ""));
    },
    async mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        const drawerState = localStorage.getItem("mainDrawerOpen");
        if (drawerState) {
            this.mainDrawerOpen = JSON.parse(drawerState);
        } else {
            this.mainDrawerOpen = true;
        }
        await this.getFrequentlyUsedQueries({ shops: true });
    },
    destroyed() {
        if (this.searchClientString.length > 0) Store.commit("ExportClientStore/resetClientSearch");
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    watch: {
        requestSuccess: value => {
            if (value) setTimeout(() => Store.commit("ExportClientStore/setRequestSuccess", false), 2500);
        },
        requestError: value => {
            if (value)
                setTimeout(() => {
                    Store.commit("ExportClientStore/setRequestError", false);
                    Store.commit("ExportClientStore/setErrorMessage", "");
                }, 2500);
        }
    },
    methods: {
        ...mapActions(["getFrequentlyUsedQueries"]),
        ...mapMutations("ExportClientStore", ["toggleListSettingsModal"]),
        openNewProductDrawer() {
            this.$router.push({ name: "export-client-edit", params: { clientId: "new" } });
        },
        updateClientSearch(value) {
            Store.commit("ExportClientStore/updateClientSearch", { term: value });
        },
        toggleDrawer() {
            this.mainDrawerOpen = !this.mainDrawerOpen;
            localStorage.setItem("mainDrawerOpen", this.mainDrawerOpen);
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 27 && this.imageFileDialog) {
                Store.commit("ExportClientStore/setImageFileDialog", false);
            } else if (e.keyCode === 27 && this.drawerOpen) {
                this.$router.push({ name: "export-client-list" });
            } else if (e.keyCode === 13 && document.activeElement.tagName === "INPUT") {
                Store.commit("ExportClientStore/updateClientSearch", {
                    term: document.querySelector("#searchInput").value
                });
            }
            if (
                this.activeClient &&
                Object.keys(this.activeClient).length > 0 &&
                this.activeClient.id !== "new" &&
                this.$route.name !== "export-client-edit"
            ) {
                let currentUserIndex = this.clients.findIndex(p => p.id === this.activeClient.id);
                if (e.key === "ArrowUp") {
                    if (currentUserIndex !== 0) {
                        const newClientId = this.clients[currentUserIndex - 1].id;
                        Store.dispatch("ExportClientStore/getClientData", newClientId);
                        this.$router.push({ name: this.$route.name, params: { clientId: newClientId } });
                    }
                } else if (e.key === "ArrowDown") {
                    if (currentUserIndex + 1 !== this.clients.length) {
                        const newClientId = this.clients[currentUserIndex + 1].id;
                        Store.dispatch("ExportClientStore/getClientData", newClientId);
                        this.$router.push({ name: this.$route.name, params: { clientId: newClientId } });
                    }
                }
            }
        },
        controlSearchString(value) {
            if (value == "") {
                Store.dispatch("SearchHistoryStore/getSearchHistory", this.$route.path.replace("/", ""));
                this.updateClientSearch(value);
            }
        }
    },
    computed: {
        ...mapState("ExportClientStore", [
            "drawerOpen",
            "searchClientString",
            "requestSuccess",
            "activeClient",
            "clients",
            "imageFileDialog",
            "requestError",
            "errorMessage"
        ]),
        ...mapGetters("ExportClientStore", ["clientCount"]),
        ...mapState("SearchHistoryStore", ["searchHistory"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    }
};
</script>

<style scoped>
.v-input__icon--prepend-inner .v-icon {
    margin-top: 0px !important;
}
</style>
